import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@menlo/ui/utils';

const alertVariants = cva(
  'relative w-full rounded-lg border px-4 py-3 text-sm text-foreground [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7',
  {
    variants: {
      variant: {
        default: 'bg-background',
        destructive: 'border-destructive/50 text-destructive [&>svg]:text-destructive bg-destructive/10',
        warning: 'border-warning/50 [&>svg]:text-warning bg-warning/10',
        info: 'border-info/50 [&>svg]:text-info bg-info/10',
        success: 'border-success/50 text-success-foreground [&>svg]:text-success bg-success/10',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

function Alert({ className, variant, ...props }: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div role="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}

function AlertTitle({ className, ...props }: React.ComponentProps<'h5'>) {
  return <h5 className={cn('mb-1 font-medium leading-none tracking-tight', className)} {...props} />;
}

function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('text-sm [&_p]:leading-relaxed', className)} {...props} />;
}

export { Alert, AlertTitle, AlertDescription };
